import { NavigationMenu, NavigationItem } from './NavigationMenu'
import { Button } from 'shared/ui/button'
import { X } from 'lucide-react'
import { useSystemBranding } from 'shared/branding/SystemBrandingProvider'

interface EptwSidebarProps {
  navigationItems: NavigationItem[]
  currentPath: string
  currentUser: any
  selectedSite?: { name?: string; location?: string }
  isCollapsed: boolean
  onNavigate: (path: string) => void
  isMobile?: boolean
  onCloseMobile?: () => void
}

export function EptwSidebar({
  navigationItems,
  currentPath,
  currentUser,
  selectedSite,
  isCollapsed,
  onNavigate,
  isMobile = false,
  onCloseMobile,
}: EptwSidebarProps) {
  const { branding } = useSystemBranding()

  const sidebarContent = (
    <>
      <div className={`border-b px-3 py-4 ${isMobile ? 'flex items-start justify-between gap-3' : ''}`}>
        <div className={`flex-1 ${isMobile ? '' : 'text-center'}`}>
          <div className={isCollapsed && !isMobile ? 'flex justify-center' : 'flex justify-center'}>
            {branding.logoUrl ? (
              <img
                src={branding.logoUrl}
                alt={branding.systemName}
                className={`${isCollapsed && !isMobile ? 'h-10 w-10' : 'h-16 w-auto'} object-contain`}
              />
            ) : (
              <div className="flex h-12 w-12 items-center justify-center rounded bg-blue-600 text-base font-bold text-white">
                {branding.systemName.slice(0, 1)}
              </div>
            )}
          </div>
          {!isCollapsed || isMobile ? (
            <p className="mt-3 text-center text-base font-semibold leading-tight text-gray-900">
              IRPC E-PERMIT PLATFORM
            </p>
          ) : null}
        </div>
        {isMobile && onCloseMobile ? (
          <Button variant="ghost" size="sm" onClick={onCloseMobile}>
            <X className="w-4 h-4" />
          </Button>
        ) : null}
      </div>

      <div className="flex-1 overflow-y-auto px-3 py-3">
        <NavigationMenu
          items={navigationItems}
          currentPath={currentPath}
          onNavigate={onNavigate}
          currentUser={currentUser}
          isCollapsed={isCollapsed && !isMobile}
        />
      </div>
    </>
  )

  if (isMobile) {
    return (
      <div className="flex h-full w-72 flex-col bg-white shadow-lg">
        {sidebarContent}
      </div>
    )
  }

  return (
    <div
      className={`hidden min-h-screen shrink-0 border-r bg-white shadow-sm transition-all duration-300 lg:flex lg:flex-col ${
        isCollapsed ? 'w-16' : 'w-72'
      }`}
    >
      {sidebarContent}
    </div>
  )
}
